



































































































import Vue from "vue";
import moment from 'moment'

interface resourceItem {
  _id: string;
  name: string;
}

interface schemaItem {
  display: string;
  key: string;
  order?: number;
}

export default Vue.extend({
  props: {
    canEdit: {
      type: Boolean
    },
    fullscreen: {
      type: Boolean
    },
    items: {
      type: Array as () => Array<resourceItem>,
      default: () => []
    },
    filter: {
      type: Object,
      default() {
        return {
          fields: {} as any
        }
      }
    },
    resource: {
      type: String,
      default: null
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    },
    search: {
      type: Object,
      default() {
        return {
          value: ""
        }
      }
    },
    sort: {
      type: Object,
      default() {
        return {
          field: "name",
          direction: "asc"
        }
      }
    }
  },
  data() {
    return {
      fullscreenImage: {
        show: false,
        viewId: null as String | null
      },
      showDetails: {}
    }
  },
  computed: {
    _items: {
      get() {
        //@ts-ignore
        let items = this.items
        //@ts-ignore
        const fields = Object.entries(this.filter.fields)
        //@ts-ignore
        const searchText = this.search.value

        if (searchText != "") {
          // const score = 0
          const words = searchText.toLowerCase().split(";");
          items = items.filter(document => {
            return words.every(
              string =>
                JSON.stringify(Object.values(document))
                  .toLowerCase()
                  .indexOf(string.trim()) > -1
            )
          })
        }
        
        if (fields.length) {
          fields.forEach(field => {
            items = items.filter(item => {
              return (item[field[0]] == field[1]) || (field[1] == undefined)
            })
          })
        }
        items.sort((a,b) => {
          let sort = 0
          //@ts-ignore
          const c = typeof a[this.sort.field] == 'string' ? a[this.sort.field].toLowerCase() : a[this.sort.field]
          //@ts-ignore
          const d = typeof b[this.sort.field] == 'string' ? b[this.sort.field].toLowerCase() : b[this.sort.field]

          if (c != undefined && d != undefined) {
            sort = c > d ? -1 : c < d ? 1 : 0
          } else if (c != undefined) {
            sort = -1
          } else if (d != undefined) {
            sort = 1
          }
          //@ts-ignore
          return this.sort.direction == 'desc' ? sort : sort * -1
        })
        return items
      },
      set(items) {
        items.forEach(item => this.showDetails = item.showDetails || false)
      }
    },
    _schema() {
      const schema: any[] = [];
      //@ts-ignore
      Object.entries(this.schema).forEach(([key, props]) =>
        schema.push({ key, ...props })
      );
      return schema;
    },
    schemaFields(): any[] {
      const schema: any = this._schema;
      schema.sort((a, b) => {
        if (a.order != undefined && b.order != undefined) {
          return a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
        } else if (a.order != undefined) {
          return -1;
        } else if (b.order != undefined) {
          return 1;
        } else {
          return 0;
        }
      });
      return schema.filter(
        field => (field.display == "meta") && field.key != "name"
      );
    }
  },
  methods: {
    hideFullscreenImage() {
      this.fullscreenImage = {
        show: false,
        viewId: null
      }
    },
    showFullscreenImage(viewId) {
      this.fullscreenImage = {
        show: true,
        viewId 
      }
    },
    imageOverlayStyle(view) {
      if (!view.upToDate) {
        const _now = new Date().valueOf();
        const _then = new Date(view.latestImageDate ? view.latestImageDate.seconds * 1000 : 0);
        const now = _now.valueOf()
        const then = _then.valueOf()
        const interval = view.captureInterval;
        const notice = interval + 5 * 60 * 1000;
        const warning = interval + 15 * 60 * 1000;
        const danger = interval + 60 * 60 * 1000;
        const neutral = interval + 24 * 60 * 60 * 1000;
        if (!interval || now - then > neutral) {
          return {
            background: "rgba(0,0,0,0.6)",
            color: "white"
          };
        } else if (!interval || now - then > danger) {
          return {
            background: "rgba(255,0,0,0.6)",
            color: "white"
          };
        } else if (now - then > warning) {
          return {
            background: "rgba(255,127,0,0.6)",
            color: "white"
          };
        } else if (now - then > notice) {
          return {
            background: "rgba(255,255,0,0.6)",
            color: "black"
          };
        }
      }

      return {
        background: "rgba(0,127,63,0.6)"
      };
    },
    isImage(value): boolean {
      if (typeof value == "string") {
        value = value.split("?")[0];
        if (value.slice(value.length - 4).toLowerCase() == ".png") {
          return true;
        } else if (value.slice(value.length - 4).toLowerCase() == ".jpg") {
          return true;
        } else if (value.slice(value.length - 5).toLowerCase() == ".jpeg") {
          return true;
        }
      }
      return false;
    }
  },
  filters: {
    ago(milliseconds) {
      return moment(milliseconds).fromNow()
    },
    minutes(time) {
      return Math.round(moment.duration(time).asMinutes())
    }
  }
});
